var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderstandRemote2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 2.33333V9.36C9.84188 9.65351 10.2392 10.1066 10.4638 10.6489C10.6885 11.1913 10.7279 11.7926 10.576 12.3596C10.424 12.9266 10.0892 13.4277 9.62353 13.785C9.15781 14.1424 8.58719 14.3361 8.00016 14.3361C7.41314 14.3361 6.84252 14.1424 6.3768 13.785C5.91108 13.4277 5.57629 12.9266 5.42436 12.3596C5.27243 11.7926 5.31184 11.1913 5.53648 10.6489C5.76113 10.1066 6.15845 9.65351 6.66683 9.36V2.33333C6.66683 1.97971 6.80731 1.64057 7.05736 1.39052C7.3074 1.14048 7.64654 1 8.00016 1C8.35379 1 8.69292 1.14048 8.94297 1.39052C9.19302 1.64057 9.3335 1.97971 9.3335 2.33333Z",
    stroke: "#9810FA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstandRemote2Icon);
export default __webpack_public_path__ + "static/media/understand_remote_2_icon.5949d9ccdbfa59e8acef92f1b80d4cdf.svg";
export { ForwardRef as ReactComponent };